import {
    Component,
    OnInit,
    AfterViewInit,
    ViewChild,
    ElementRef,
    HostListener,
} from '@angular/core';

@Component({
    selector: 'scroll-view',
    templateUrl: 'scroll-view.component.html',
    styleUrls: ['./scroll-view.component.scss'],
    standalone: false
})
export class ScrollViewComponent implements OnInit, AfterViewInit {
    @ViewChild('scrollWrapper') public scrollWrapper?: ElementRef;
    public scrollViewHeight = 0;
    public scrollViewWidth = 0;

    public constructor() {}
    public ngAfterViewInit(): void {
        //setTimeout нужен для того, чтобы ангуляр не выбрасывал ошибку,
        //что значение типа было изменено. Можно поправить, но вроде это не критично
        setTimeout(() => {
            this.updateScrollSize();
        }, 0);
    }

    public ngOnInit() {}
    @HostListener('window:resize', ['$event'])
    public onResize(event: any) {
        this.updateScrollSize();
    }

    public updateScrollSize() {
        if (this.scrollWrapper) {
            this.scrollViewHeight =
                this.scrollWrapper.nativeElement.offsetHeight;
            this.scrollViewWidth = this.scrollWrapper.nativeElement.offsetWidth;
        }
    }
}
